export default __webpack_public_path__ + "static/media/Maithili_book_f.0897fa90.wav";